import { ROUTE_PATHS } from '@dmp/constant';

export function AppLayoutFooter() {
  return (
    <div className="pt-3 mb-[50px] mt-[50px] text-center text-[#5c5c5c] text-[14px] border-t border-[#BDA9EC]">
      <div className="mb-2">© {new Date().getFullYear()} Centific. All Rights Reserved </div>
      <ul className="flex gap-5 justify-center">
        <li>
          <a href={ROUTE_PATHS.PRIVACY_POLICY} target="_blank" className="underline">
            Privacy Policy
          </a>
        </li>
        <li className="relative before:content-[''] before:w-[1px] before:h-full before:bg-[#d6d6d6] before:absolute before:top-0 before:left-[-10px]">
          <a href={ROUTE_PATHS.TERMS_OF_USE} target="_blank" className="underline">
            Terms & Conditions
          </a>
        </li>
        <li className="relative before:content-[''] before:w-[1px] before:h-full before:bg-[#d6d6d6] before:absolute before:top-0 before:left-[-10px]">
          <a href={ROUTE_PATHS.COOKIE_POLICY} target="_blank" className="underline">
            Cookie Policy
          </a>
        </li>
        <li className="relative before:content-[''] before:w-[1px] before:h-full before:bg-[#d6d6d6] before:absolute before:top-0 before:left-[-10px]">
          <a href={ROUTE_PATHS.FAQ} target="_blank" className="underline">
            FAQ
          </a>
        </li>
      </ul>
    </div>
  );
}
